import { EICSTatus } from './eic-status.enum';

export class EmployeeInCharge {
  eicEmployeeId: string;
  eicEmployeeName: string;
  eicUserId: string;
  employeeInChargeId: string;
  primary: boolean;
  status: EICSTatus;
  lastChangeRequestStatus?: string;
  entryMilepostPrefix: string;
  entryMilepostId: string;
  qualifiedSubDivisionCodes?: Array<string>;
  comment?: string;
  selected?: number;
  rejectReason?: string;

  constructor(employeeInCharge: IEmployeeInCharge) {
    this.eicEmployeeId = employeeInCharge.eicEmployeeId;
    this.eicEmployeeName = employeeInCharge.eicEmployeeName;
    this.eicUserId = employeeInCharge.eicUserId;
    this.employeeInChargeId = employeeInCharge.employeeInChargeId;
    this.primary = employeeInCharge.primary;
    this.status = employeeInCharge.status;
    this.entryMilepostPrefix = employeeInCharge.entryMilepostPrefix;
    this.entryMilepostId = employeeInCharge.entryMilepostId;
    this.lastChangeRequestStatus = employeeInCharge.lastChangeRequestStatus;
    this.rejectReason = employeeInCharge.rejectReason;

    this.comment = employeeInCharge.comment;
    this.selected = employeeInCharge.selected;
    if (employeeInCharge.qualifiedSubDivisionCodes !== undefined) {
      this.qualifiedSubDivisionCodes = new Array<string>();
      for (let i = 0; i < employeeInCharge.qualifiedSubDivisionCodes.length; i++) {
        this.qualifiedSubDivisionCodes.push(employeeInCharge.qualifiedSubDivisionCodes[i]);
      }
    }
  }
}

export interface IEmployeeInCharge {
  eicEmployeeId: string;
  eicEmployeeName: string;
  eicUserId: string;
  employeeInChargeId: string;
  primary: boolean;
  status: EICSTatus;
  lastChangeRequestStatus?: string;
  qualifiedSubDivisionCodes: Array<string>;
  entryMilepostPrefix: string;
  entryMilepostId: string;
  comment?: string;
  selected?: number;
  rejectReason?: string;
}
